/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TagsInputs */



/**

* @param {_Field_TagsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_tags = /** @type {((inputs?: _Field_TagsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TagsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Tags")
});